import { render } from "./Experience.vue?vue&type=template&id=77a8757c&scoped=true"
const script = {}

import "./Experience.vue?vue&type=style&index=0&id=77a8757c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src286570729/src/astaykov-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a8757c"]])

export default __exports__